"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../Header.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The content to be shown in the header.
 * The content can include any element(s). But common elements
 * included are the current coordinate and current scale.
 * By default,  the elements in the Content will be placed
 * in the horizontal direction.
 * @visibleName Header.Content
 */
var Content = function Content(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "rolext-header-content",
    style: style,
    children: children
  });
};

Content.propTypes = {
  /**
   * A CSS Style to render the Content
   */
  style: _propTypes.default.object,

  /**
   * The children node of the Content
   */
  children: _propTypes.default.node.isRequired
};
var _default = Content;
exports.default = _default;